<template>
  <div class="account-tabs__navs-mob d-none d-sm-flex select-dropdown">
    <button
      class="account-tabs__navs-mob-trigger"
      type="button"
      :class="{ _new: true }"
      @click="openMobileTabs()"
    >
      <span>{{ (tabs[current] || {}).name }}</span>
      <BaseSvg name="ico-arrow" />
    </button>

    <transition name="dropdown">
      <div
        v-if="showMobileTabs"
        v-click-out="closeMobileTabs"
        class="select-dropdown__dropdown"
      >
        <button
          class="select-dropdown__close"
          type="button"
          @click.prevent="closeMobileTabs()"
        >
          <BaseSvg
            name="ico-close"
            width=".8rem"
            height=".8rem"
          />
        </button>

        <AccountTabsNavs
          class="select-dropdown__options"
          button-class="account-tabs__navs-mob-item"
          :tabs="tabs"
          :current="current"
          @change="$emit('change', $event)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
  import AccountTabsNavs from '@/components/accountTabs/AccountTabsNavs'

  export default {
    name: 'AccountTabsNavsMob',
    components: {
      AccountTabsNavs
    },

    props: {
      tabs: {
        type: Array,
        default: () => []
      },
      current: {
        type: Number,
        default: 0
      }
    },

    data: () => ({
      showMobileTabs: false
    }),

    watch: {
      current(value, old) {
        if (value !== old) this.closeMobileTabs();
      }
    },

    methods: {
      openMobileTabs() {
        this.showMobileTabs = true;
      },

      closeMobileTabs() {
        this.showMobileTabs = false;
      }
    }
  };
</script>
